<template>
  <div class="list_index">
    <el-table stripe :data="tableData">
      <el-table-column label="设备序列号" prop="serialNumber" align="center"></el-table-column>
      <el-table-column label="联系人" prop="contacts" align="center"></el-table-column>
      <el-table-column label="手机号" prop="phoneNumber" align="center"></el-table-column>
      <el-table-column label="地址" prop="address" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="报修原因" prop="problemDescription" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.serviceProgress == '2'" type="text" size="mini" @click="repair(scope.row)">派工</el-button>
          <p v-else-if="scope.row.serviceProgress == '3'">已派工</p>
          <p v-else-if="scope.row.serviceProgress == '4'">维修中</p>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
      ></el-pagination>
    </div>
    <el-dialog title="派工" :visible.sync="showRepair" width="20%">
      <el-select v-model="repairPersonnel" placeholder="请选择维修人员" style="width:260px">
        <el-option v-for="(item,index) in List" :key="index" :label="item.user_realname" :value="index"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editCanel" size="mini" class="yl-button2">取 消</el-button>
        <el-button type="primary" size="mini" class="yl-button" @click="dispatchMaintenance()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RepairService from '@/api/repair';
import DataService from '@/api/data';
export default {
  data(){
    return{
      page: 1,
      count: 0,
      size:10,
      tableData:[],
      showRepair:false,
      repairPersonnel:'',
      workOrderNo:'',
      List:[]
    }
  },
  methods:{
    //获取表格数据
    getDataList(){
      RepairService.getCheckRepair({
        user_id:this.$store.state.user_id,
        page:this.page,
        size:this.size,
        list:['2','3','4']
      }).then(res=>{
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    //获取工人列表
    getPersonList(){
      DataService.getUserJurisdictionInfo({
        user_id:this.$store.state.user_id
      }).then(res=>{
        this.List = res.data;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    repair(val){
      this.showRepair = true;
      this.workOrderNo = val.workOrderNo;
    },
    editCanel(){
      this.showRepair = false;
    },
    //派工
    dispatchMaintenance(){
      RepairService.dispatchMaintenance({
        maintenanceUserId:this.List[this.repairPersonnel].user_id,
        name:this.List[this.repairPersonnel].user_realname,
        workOrderNo:this.workOrderNo
      }).then(res=>{
        this.$message.success('派工成功');
        this.showRepair = false;
        this.getDataList();
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page) {
      this.page = page;
      this.getDataList();
    },
  },
  mounted(){
    this.getDataList();
    this.getPersonList();
  }
}
</script>

<style>

</style>